import { Link } from 'react-router-dom';

export default function CtaBand() {
  return (
    <section className="relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=cozy%20evening%20anime%20illustration%20of%20a%20warm%20window%20seat%20with%20milk%20and%20books%20under%20a%20glowing%20lantern%20under%20a%20starry%20night%20sky%2C%20relaxing%20healing%20mood%2C%20soft%20warm%20golden%20tones%2C%20anime%20background%20art&width=1600&height=500&seq=home-cta&orientation=landscape"
        alt="牛奶动漫库温馨夜景氛围插画"
        title="加入牛奶动漫库补番清单"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-foreground-950/60"></div>
      <div className="relative z-10 mx-auto flex max-w-7xl flex-col items-center gap-5 px-4 py-16 text-center md:px-6 md:py-24">
        <h2 className="font-heading text-2xl font-bold text-background-50 md:text-4xl">
          今晚，用一杯牛奶的时间治愈自己
        </h2>
        <p className="max-w-2xl text-sm leading-relaxed text-background-100 md:text-base">
          无论你是治愈系爱好者，还是只想找点轻松的日常番，牛奶动漫库都能帮你快速锁定下一部心头好。
        </p>
        <div className="flex flex-col gap-3 sm:flex-row">
          <Link
            to="/category/healing"
            className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition hover:bg-primary-600"
          >
            <i className="ri-heart-line"></i>
            逛逛治愈番
          </Link>
          <Link
            to="/category/daily"
            className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-background-50/95 px-6 py-3 text-sm font-medium text-foreground-950 transition hover:bg-background-50"
          >
            <i className="ri-plant-line"></i>
            看看日常番
          </Link>
        </div>
      </div>
    </section>
  );
}